import { createSlice } from "@reduxjs/toolkit";
import { GetWorkoutByUserIdServices } from "./thunk";



const workoutSlice = createSlice({
    name: 'workout',
    initialState: {
        workout: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(GetWorkoutByUserIdServices.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(GetWorkoutByUserIdServices.fulfilled, (state, action) => {
            state.loading = false;
            state.workout = action.payload.data;
        }).addCase(GetWorkoutByUserIdServices.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
    }
});

export default workoutSlice.reducer;

